import { z } from 'zod';
import { UserRole } from '../constants/session.constants';

export const ChatMessageSchema = z.object({
  id: z.string().uuid(),
  sessionId: z.string().uuid(),
  senderRole: z.nativeEnum(UserRole),
  senderName: z.string().trim().min(1).max(100),
  message: z.string().trim().min(1).max(500),
  timestamp: z.number().int().positive()
});

export const SendChatMessageSchema = z.object({
  message: z.string().trim().min(1, 'El mensaje no puede estar vacío').max(500, 'Máximo 500 caracteres')
});

export type ChatMessage = z.infer<typeof ChatMessageSchema>;
export type SendChatMessage = z.infer<typeof SendChatMessageSchema>;
